<template>
  <div class="container">
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Balance de oferta y demanda de biomasa</h1>
      <hr>
      <p class="texto-principal">El siguiente mapa nos muestra el balance entre oferta y consumo de biomasa a nivel municipal, es decir, se contabiliza la cantidad de biomasa que existe en cada municipio y se resta con la demanda de cada uno de los municipios. Las tonalidades naranjas y rojas, nos indican un déficit de biomasa, la demanda supera la oferta que existe en esos municipios.  </p>
    </div>
    <div>
      

      

      <dai-tarjeta-contenedor-mapa :permitir-colapso="true" :es-version-escritorio-en-pantalla-larga="false">
      
        <template v-slot:header>
              <h3>Balance de biomasa forestal en México por municipio. Oferta forestal vs demanda</h3>
              

              
              <p>Datos en toneladas de materia seca por año (tMS/año)</p>
              


              <dai-leyenda-mapa v-width-control="'70%'"
              titulo="Balance de biomasa forestal (tMS/año)"
              :para="['balance_od']"
              :tamanosDeMapa="true"
              />

              <dai-interruptor-mapa v-width-control="'30%'"
                v-model="capa_prendida"
                :opciones="['Mapa','Satélite']"
                /> 
              
        </template>

        
        
        <dai-mapa
        :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
        >
            
        <dai-capa-xyz id="Mapa" :visible="capa_prendida==='Mapa'" url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>

        <dai-capa-xyz id="Satélite" :visible="capa_prendida==='Satélite'" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"/>

        <dai-capa-topojson  
            id="balance_od" 
            url="../geodata/biomasa/balance_biomasa.json"
            titulo="Balance de biomasa forestal en México por Municipio oferta forestal vs demanda"
            :zoom-al-dar-click="false"
            :contenidoPopup="(feat)=>`<b>Municipio:</b> ${feat.nomgeo}, ${feat.nom_ent}<br><b>Demanda:</b> ${feat.balance3} `"
            :estilo-capa="{
            stroke:{
                color:'#333',                
                width:0.5
              }
            }"
            :reglas-estilo-capa="{
                clasificacion:'personalizada',
                columna : 'balance3',
                propiedadObjetivo: 'relleno',
                clases: 6,
                clasificacionPersonalizada: [[0,0],[-112286,-50000],[-50000,-1],[1,20000],[20000,40000],[40000,2553290]],
                colores: ['#c8c8c8','#fc0000', '#fb9f42','#f9fa78','#a8fca4','#13b597'],

            }"
          />

        </dai-mapa>
          
      </dai-tarjeta-contenedor-mapa>


    </div>

    <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
        <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
        <ul class="lista-referencias">
          <li><em><strong>Cluster de biocombustibles sólidos (CBCS) (2018).</strong></em> Plataforma geoespacial para la planeación bioenergética. Recuperado en enero 2023. <a href="https://wegp.unam.mx/cemie/Mexico#" target="_blank">https://wegp.unam.mx/cemie/Mexico#</a></li>
          <li><em><strong>Servicio de Información Agroalimentaria y Pesquera (SIAP) (2022).</strong></em> Anuario Estadístico de la Producción Agrícola. Recuperado en enero 2023. <a href="https://nube.siap.gob.mx/cierreagricola/" target="_blank">https://nube.siap.gob.mx/cierreagricola/</a></li>
          <li><em><strong>Comisión Reguladora de Energía (CRE) (2022).</strong></em> Registro público del órgano de gobierno.  Recuperado en diciembre de 2022. <a href="https://www.cenace.gob.mx/" target="_blank">https://www.cenace.gob.mx/</a></li>
        </ul>            
    </div>


  </div>
</template>
<script>
  
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  

  import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";

  am4core.useTheme(am4themes_kelly);
  

  export default {
    name: 'App',
    components: {
      
    },
    data: function () {
      return {
        capa_prendida: 'Mapa'
      }   
    },
    mounted() {

      
      

      

    },
    beforeDestroy() {
     
    },
  }

</script>
<style scoped lang="scss">


</style>
